import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { ResetPasswordForm } from "@/components/forms/supervisor-reset-password-form";
import { Image } from "@/components/image";
import { Logo } from "@/components/logo";

const routeApi = getRouteApi("/supervisors/resetPassword/$token");

const ResetPasswordPage = () => {
  const { token } = routeApi.useParams();

  return (
    <div className="container relative hidden min-h-[100dvh] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
      <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
        <div className="absolute inset-0 bg-zinc-900">
          <Image
            src="/img/20170222-OSCAR-Radio-001-scaled.jpg"
            width={1280}
            height={843}
            alt="Authentication"
            className="block h-full object-cover"
          />
        </div>
        <div className="relative z-20 flex items-center text-lg font-medium gap-4">
          <Logo forDirectors={true} />
        </div>
      </div>
      <div className="lg:p-8">
        <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
          <div className="flex flex-col space-y-2 text-center">
            <h1 className="text-2xl font-semibold tracking-tight">
              Reset your password
            </h1>
            <p className="text-sm text-muted-foreground">
              Just enter your new password below! This change is permanent
            </p>
          </div>
          <ResetPasswordForm token={token} />
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/supervisors/resetPassword/$token")({
  component: ResetPasswordPage,
});
